import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Col, Input, FormGroup, Row, Button, Label} from 'reactstrap';

import AddRemoveList from './AddRemoveListComponent';
import YesNoModal from '../YesNoModalComponent';

import axios from 'axios';
import {serverPath} from '../common';


class TopicEdit extends Component
{
	constructor(props)
	{
		super(props);
		this.state =
			{
				topicData:
					{
						courseId: props.course ? props.course.id: 0,
						type:0,
						...props.topicData,
					},
				problems:props.topicProblems,
				problemToDelete:-1,
				confirmDeleteModalData:
					{
						show:false,
						text:'',
					}
			};

		this.typeOptions =
			[
				{value:0, text:''},
				{value:1, text:'Tema vezbi'},
				{value:2, text:'Kolokvijum'},
				{value:3, text:'Primer Kolikvijuma'},
				{value:4, text:'Ispit'},
				{value:5, text:'Primer Ispita'},
			]

		this.onTypeSelect = this.onTypeSelect.bind(this);
		this.onCourseIdChange = this.onCourseIdChange.bind(this);
		this.onTopicWeekChange = this.onTopicDataChange.bind(this, 'week');
		this.onTopicYearChange = this.onTopicDataChange.bind(this, 'year');
		this.onTopicNameChange = this.onTopicDataChange.bind(this, 'name');
		this.onTopicDescriptionChange= this.onTopicDataChange.bind(this, 'description');
		this.onTopicExamIdxChange = this.onTopicDataChange.bind(this, 'examIdx');
		this.onAddProblem = this.onAddProblem.bind(this);
		this.onRemoveProblem = this.onRemoveProblem.bind(this);
		this.renderItem = this.renderItem.bind(this);
		this.onAccept = this.onFinish.bind(this, true);
		this.onReject = this.onFinish.bind(this, false);
		this.onToggleConfirmDeleteModal = this.onToggleConfirmDeleteModal.bind(this);
		this.onPositiveConfirmDeleteProblem = this.onConfirmDelete.bind(this, true);
		this.onNegativeConfirmDeleteProblem = this.onConfirmDelete.bind(this, false);
		this.onNameChange = props.onNameChange ? props.onNameChange : ()=>{};
	}



	/*Life cycle code*/

	componentDidUpdate(prevProps)
	{
		if(prevProps.topicData !== this.props.topicData ||
			prevProps.topicProblems !== this.props.topicProblems)
		{
			this.onPropsChange();
		}
	}

	/*View/handler code*/
	onPropsChange()
	{

		if(this.props.creating === undefined || this.props.creating === false)
		{
			let topicData =
					{
						...setTopicType(this.state.topicData,this.props.topicData.type),
						...setTopicCourseId(this.state.topicData, this.props.topicData.idCourse),
					};

			if(this.props.topicData.description)
			{
				topicData = {...topicData, ...setTopicDescription(this.state.topicData,
									this.props.topicData.description)};
			}
			else
			{
				topicData = {...topicData, ...setTopicDescription(this.state.topicData, '')};
			}

			if(this.props.topicData.name)
			{
				topicData = {...topicData, ...setTopicName(topicData, this.props.topicData.name)};
			}
			else
			{
				topicData = {...topicData, ...setTopicName(topicData, '')};
			}

			if(this.props.topicData.week)
			{
				topicData = {...topicData, ...setTopicWeek(topicData, this.props.topicData.week)};
			}

			if(this.props.topicData.year)
			{
				topicData = {...topicData, ...setTopicYear(topicData, this.props.topicData.year)};
			}

			if(this.props.topicData.examIdx)
			{
				topicData = {...topicData, ...setTopicExamIdx(topicData, this.props.topicData.examIdx)};
			}

			this.setState(
					{
						...setProblems(this.props.topicProblems),
						topicData:topicData
					});
		}

		setTimeout(()=>this.onNameChange(buildName(this.state.topicData)), 0);
	}

	onTypeSelect(event)
	{
		this.setState(resetToType(this.state, parseInt(event.target.value, 10)));
		setTimeout(()=>this.onNameChange(buildName(this.state.topicData)),0);
	}

	onCourseIdChange(event)
	{
		this.setState(setTopicData(
			this.state,
			setTopicCourseId(this.state.topicData, parseInt(event.target.value, 10)))
		);
	}

	onTopicDataChange(filed, event)
	{
		if(filed === 'year')
		{
			let year = parseInt(event.target.value, 10);
			if(!year)
			{
				year = TopicEdit.minYear;
			}

			this.setState(setTopicData(
				this.state,
				setTopicYear(this.state.topicData, year)
			));
		}
		else if(filed === 'week')
		{
			let week = parseInt(event.target.value, 10);
			if(!week)
			{
				week = TopicEdit.minWeek;
			}

			this.setState(setTopicData(
				this.state,
				setTopicWeek(this.state.topicData, week)
			));
		}
		else if(filed === 'name')
		{
			this.setState(setTopicData(
				this.state,
				setTopicName(this.state.topicData, event.target.value)
			));
		}
		else if(filed === 'description')
		{
			this.setState(setTopicData(
				this.state,
				setTopicDescription(this.state.topicData, event.target.value)
			));
		}
		else if(filed === 'examIdx')
		{
			this.setState(
				setTopicData(
					this.state,
					setTopicExamIdx(this.state.topicData, event.target.value))
			);
		}

		setTimeout(()=>this.onNameChange(buildName(this.state.topicData)), 0);

	}

	onAddProblem()
	{
		alert('not implemented');
	}

	onRemoveProblem(index)
	{
		this.setState(
			{
				...setProblemToDelete(this.state, index),
				...setConfirmDeleteModalData(this.state,
					{
						...this.state.confirmDeleteModalData,
						...toggleConfirmDeleteModal(this.state.confirmDeleteModalData),
						...setConfirmDeleteModalText(this.state.confirmDeleteModalData,
							(<div>Da li ste sigurni da zelite da izbrisete zadatak
							<b> {this.state.problems[index].name}</b>!?</div>))
					})
			}
		);
	}

	onFinish(accept)
	{
		const isCreating = this.props.creating !== undefined && this.props.creating;
		if(accept)
		{
			const tmp = {};
			if(!isCreating)
			{
				tmp.topicId = this.props.topicId;
			}

			axios.post(`${serverPath}/professorService.php`,
					{
						...tmp,
						topicData:this.state.topicData,
					},
					{
						params:
							{
								action:  isCreating ? 'createTopic' : 'updateTopic'
							}
					})
				.then((response)=>
				{
					this.props.onFinish(
						{
							topicId:response.data.topicId,
							topicData:this.state.topicData
						});
				});

		}
		else
		{
			this.props.onFinish(null);
		}
	}

	onToggleConfirmDeleteModal()
	{
		this.setState(setConfirmDeleteModalData(
			this.state,
			toggleConfirmDeleteModal(this.state.confirmDeleteModalData)
		));
	}

	onConfirmDelete(confirm)
	{
		if(confirm)
		{
			axios.post(`${serverPath}/professorService.php`,
				{
					problemId:this.state.problems[this.state.problemToDelete].idProblem
				},
				{
					params:
						{
							action:'deleteProblem'
						}
				});

			this.setState(
				{
					...setProblemToDelete(this.state, -1),
					...removeProblemAt(this.state, this.state.problemToDelete)

				}
			);
		}
		else
		{
			this.setState(setConfirmDeleteModalData(this.state,setProblemToDelete(this.state, -1)));
		}

	}

	/*Render code*/

	renderOptions(options, selected)
	{
		return options.map((el, index) =>
		{
			const props = {selected: selected === el.value};
			return (
				<option value={el.value} {...props}>{el.text}</option>
			);
		})
	}

	renderSelection()
	{
		const disabled = {disabled:this.props.creating && this.props.topicData.type};
		return (

			<Row>
				<Col xs='4'>
					<Input type='select' onChange={this.onTypeSelect} {...disabled}>
						{this.renderOptions(this.typeOptions, this.state.topicData.type)}
					</Input>
				</Col>
			</Row>
		);
	}

	renderBody()
	{
		if(this.state.topicData.type === 0)
		{
			return (
				<Row className='justify-content-center'>
					<Col xs='auto'>
						Molimo Vas odaberite tip topica
					</Col>
				</Row>
			);
		}
		else
		{
			let col = null;
			let examIdx = null;
			if(this.state.topicData.type === 1)
			{
				col = (
					<Col sm='12' md='4' lg='2'>
						<FormGroup>
							<Label>Tema</Label>
							<Input type='number' min={TopicEdit.minWeek}
								   onChange={this.onTopicWeekChange}
								   value={this.state.topicData.week}
							/>
						</FormGroup>
					</Col>
				);
			}
			else
			{
				col = (
					<Col sm='12' md='4' lg='2'>
						<FormGroup>
							<Label>Godina</Label>
							<Input type='number' min={TopicEdit.minYear}
								   onChange={this.onTopicYearChange}
								   value={this.state.topicData.year}
							/>
						</FormGroup>
					</Col>
				);

				if(this.state.topicData.type === 4 || this.state.topicData.type === 5 ||
					this.state.topicData.type === 2 || this.state.topicData.type === 3)
				{
					examIdx = (
						<Col sm='12' md='6' lg='3'>
							<FormGroup>
								<Label>Indeks ispista</Label>
								<Input type='number' min={0}
									   onChange={this.onTopicExamIdxChange}
									   value={this.state.topicData.examIdx}
								/>
							</FormGroup>
						</Col>
					);

				}

			}

			return (
				<React.Fragment>
					<Row className={'mt-2'}>
						{col}
						{examIdx}
						<Col>
							<FormGroup>
								<Label>Naziv</Label>
								<Input type='text' onChange={this.onTopicNameChange}
										value={this.state.topicData.name}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row className='mt-2'>
						<Col>
							<FormGroup>
								<Label>Opis teme</Label>
								<Input type='textarea' onChange={this.onTopicDescriptionChange}
									   value={this.state.topicData.description}
									   placeholder='Opis teme'
									   style={{height:'300px'}}
								/>
							</FormGroup>
						</Col>
					</Row>
				</React.Fragment>
			);
		}
	}

	/*renderName()
	{
		let wrapName = (name)=>(
			<React.Fragment>
					<hr/>
					<Row className='justify-content-center'>
						<Col xs='auto'>
							{name}
						</Col>
					</Row>
				</React.Fragment>
		);


	}*/

	renderList()
	{
		const isCreating = this.props.creating !== undefined && this.props.creating;

		if(isCreating)
		{
			return null;
		}
		else
		{
			return (
				<React.Fragment>
					<Row>
						<Col>
							<h3>Lista zadataka za ovu temu</h3>
						</Col>
					</Row>
					<Row className='mt-2'>
						<Col>
							<AddRemoveList items={this.state.problems}
										   onAdd={this.onAddProblem}
										   onRemove={this.onRemoveProblem}
										   renderItem={this.renderItem}
										   buttonText='+ Dodaj novi zadatak'
							/>
						</Col>
					</Row>
				</React.Fragment>
			);
		}

	}
	

	renderItem(index)
	{
		const item = this.state.problems[index];
		const urlToProblem =
			`/p/courses/${this.state.topicData.courseId}/topic/${this.props.topicId}
			/problem/${item.idProblem}`;
		return (
			<Row>
				<Col xs='auto'>
					<Link to={urlToProblem}>{item.name}</Link>
				</Col>
				<Col>
					<Row className='justify-content-end'>
						<Col xs='auto'>
							<Link to={`${urlToProblem}/edit`}>
								<Button color='primary' size='sm'>Izmeni zadatak</Button>
							</Link>
						</Col>
					</Row>
				</Col>
			</Row>
		)
	}

	render()
	{

		return (
			<React.Fragment>
				{this.renderSelection()}
				{this.renderBody()}

				<Row className='justify-content-end mt-2'>
					<Col xs='auto'>
						<Button color='success' onClick={this.onAccept}>Prihvati</Button>
					</Col>

					<Col xs='auto'>
						<Button color='danger' onClick={this.onReject}>Odbaci</Button>
					</Col>
				</Row>

				<hr/>
				{this.renderList()}

				<YesNoModal yesText='Da'
							noText='Odbaci'
							title={TopicEdit.confirmDeleteTitle}
							body={this.state.confirmDeleteModalData.text}
							isOpen={this.state.confirmDeleteModalData.show}
							toggle={this.onToggleConfirmDeleteModal}
							onYes={this.onPositiveConfirmDeleteProblem}
							onNo = {this.onNegativeConfirmDeleteProblem}
				/>
			</React.Fragment>
		);
	}

}

TopicEdit.minYear = 2000;
TopicEdit.minWeek = 0;
TopicEdit.confirmDeleteTitle = 'Birsanje zadatka';

/*Presenter code*/
function resetToType(state, type)
{
	let topicData = null;
	if(!type)
	{
		type = 0;
		topicData={};
	}

	if(type === 1)
	{
		topicData = {week:TopicEdit.minWeek, name:'', description:''};
	}
	else if(type === 2 || type === 3)
	{
		topicData = {year:TopicEdit.minYear, description: '', name:''};
	}
	else if(type === 4 || type === 5)
	{
		topicData = {year:TopicEdit.minYear, name: '', description:'', examIdx: 0};
	}

	topicData.type=type;
	topicData.courseId=state.topicData.courseId;
	return {topicData:topicData};
}

function setTopicType(topicData, type)
{
	return {type:type};
}

function setTopicCourseId(topicData, id)
{
	return {courseId:id};
}

function setTopicYear(topicData, year)
{
	return {year:year};
}

function setTopicWeek(topicData, week)
{
	return {week:week};
}

function setTopicDescription(topicData, description)
{
	return {description:description};
}

function setTopicName(topicData, name)
{
	return {name:name};
}

function setTopicExamIdx(topicData, examIdx)
{
	return {examIdx:examIdx};
}



function setProblems(data)
{
	return {problems:data};
}

function toggleConfirmDeleteModal(confirmDeleteModalData)
{
	return {show:!confirmDeleteModalData.show};
}

function setConfirmDeleteModalText(confirmDeleteModalData, value)
{
	return {text:value};
}

function setProblemToDelete(state, index)
{
	return {problemToDelete:index};
}

function removeProblemAt(state, index)
{
	let pre = state.problems.slice(0, index);
	let post = state.problems.slice(index+1);

	return {problems:[...pre, ...post]};
}

function setTopicData(state, data)
{
	return (
		{
			topicData:
				{
					...state.topicData,
					...data
				}
		});
}

function setConfirmDeleteModalData(state, data)
{
	return (
		{
			confirmDeleteModalData:
				{
					...state.confirmDeleteModalData,
					...data
				}
		});
}

/*Helpers*/
/*function getAllCourses()
{
	return axios.get(`${serverPath}/professorService.php`,
		{
			params:
				{
					action:'getAllCourses'
				}
		});
}*/



function buildName(topicData)
{
	if(topicData.type === 0)
	{
		return '';
	}
	else if(topicData.type === 1)
	{
		return `Tema ${topicData.week}: ${topicData.name}`;
	}
	else if(topicData.type === 2 || topicData.type === 3)
	{
		return `${topicData.year}: ${topicData.description}`;
	}
	else
	{
		return `${topicData.year}: ${topicData.name}`;
	}
}
export default TopicEdit;
